import React from 'react';
import Checkbox from '../../../elements/forms/Checkbox';

export default class CheckboxQuestion extends React.Component {
    render() {
        let {event, question, value} = this.props,
            option = _(this.props.options).first();

        return (
            <div>
                {question.label ? <h5>{question.label}</h5> : null}
                <Checkbox
                    className="marginTop marginBottom"
                    color={event.settings.primary_color}
                    checked={_.includes(value, option.value)}
                    onChange={this.handleChange.bind(this)}>
                    {option.label_line_2 ? (
                        <div>
                            <p className="text main">{option.label}</p>
                            <p className="text">{option.label_line_2}</p>
                        </div>
                    ) : (
                        option.label
                    )}
                </Checkbox>
            </div>
        );
    }
    handleChange(checked) {
        if (checked) {
            this.props.onChange(_(this.props.options).first().value);
        } else {
            this.props.onChange([]);
        }
    }
}
